import { ASSISTANT_ENABLED } from '../constants'

export const setAssistantActive = assistantEnabled => ({
    type: ASSISTANT_ENABLED,
    assistantEnabled
  })



// WEBPACK FOOTER //
// ./src/actions/assistant.js